import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Icon } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { List, ListItem } from '@/components/List'
import { ShipperTooltip } from '@/components/ShipperTooltip'
import { Price } from '@/components/shared/Price'

import type { ReconciledChargeItem } from '../types'

type Props = {
  titleContents: ReactNode
  charges: ReconciledChargeItem[]
  total: number
  manual?: boolean
  currency?: string
  invoice?: boolean
}
export const AuditChargeList = ({
  titleContents,
  charges,
  manual,
  total,
  currency,
  invoice,
}: Props) => {
  return (
    <div className="b900:basis-full b900:max-w-none b900:mr-0 b900:mb-4 flex flex-col bg-[#fffef8] p-4 mr-4 border-fv-beer-medium border basis-[20rem] shrink-0">
      <div className="bg-[#f4ffed] -mx-4 px-4 py-2 border-[#ede9c6] border-b -mt-4 mb-4">
        {titleContents}
      </div>
      <List fcp0 lcp0 className="whitespace-nowrap flex-1 flex flex-col">
        {charges.map((charge, ix) => (
          <>
            <AuditChargeItem
              charge={charge}
              key={ix}
              className="border-fv-beer-dark"
            />
          </>
        ))}

        <ListItem
          className={clsx(
            'mt-auto fa-width-auto',
            charges.length === 0 ? 'pt-0' : 'pt-4',
          )}
        >
          {manual && (
            <ShipperTooltip label="Manually entered rate">
              <Icon icon="user" transform="up-1" className="cursor-help" />
            </ShipperTooltip>
          )}
          <span>Total {invoice ? 'invoice' : 'quote'}</span>
          <span className="ml-auto text-right pl-4 font-oxygen">
            ={' '}
            <span className="bg-fv-beer-light p-1 -mx-[calc(.25rem-1px)] border-fv-beer-medium border rounded-xs">
              <Price size="sm" amount={total} currency={currency ?? ''} />
            </span>
          </span>
        </ListItem>
      </List>
    </div>
  )
}

type ChargeItemProps = PropsWithClassName<{
  charge: ReconciledChargeItem
}>
const AuditChargeItem = ({ charge, className }: ChargeItemProps) => {
  const isNeg = charge.amount < 0

  return (
    <ListItem className={className}>
      <span className="truncate">{charge.label}</span>
      <span
        className={clsx('ml-auto text-right pl-4 flex items-center gap-x-2', {
          'text-fv-orange': isNeg,
        })}
      >
        {isNeg && (
          <span className="h-[.15rem] w-2 bg-fv-orange inline-block"></span>
        )}
        <Price size="sm" amount={Math.abs(charge.amount)} currency="" />
      </span>
    </ListItem>
  )
}
